import { render, staticRenderFns } from "./HotelGallery.vue?vue&type=template&id=03a89bcd"
import script from "./HotelGallery.vue?vue&type=script&lang=js"
export * from "./HotelGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Gallery: require('/vercel/path0/components/partials/Gallery.vue').default,Button: require('/vercel/path0/components/common/Button.vue').default,Modal: require('/vercel/path0/components/common/Modal.vue').default})
